// @ts-nocheck
import React from "react";
import { FC } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import queryString from "querystring";
import { useLocation } from "react-router";
import { RouteComponentProps } from "react-router";
import { Theme } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { fade } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "../../../../components/Button";
import Avatar from "@material-ui/core/Avatar";
import { usePayment } from "../../hooks/usePayment";
import Typography from "@material-ui/core/Typography";
import Loading from "../../../../components/Loading";
import FontIcon from "../../../../components/FontIcon";
import PageHeader from "../../../../components/PageHeader";
import Error from "../../../../components/Error";
import FooterWave from "../../../../assets/img/footer-wave.png";
import { Routes } from "../../../../../src/constants/routes";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minHeight: "70vh",
    backgroundImage: "linear-gradient(to bottom,#fff,#ece6d6)",
    position: "relative",
    paddingBottom: theme.spacing(4),

    "&:after": {
      content: "''",
      position: "absolute",
      top: "99.7%",
      height: 40,
      width: "100%",
      background: `url(${FooterWave}) top no-repeat`,
      backgroundSize: "100% 100%",
    },
  },
  paper: {
    paddingBottom: theme.spacing(4),
  },
  serviceItem: {
    padding: theme.spacing(2),
  },
  serviceItemGrid: {
    minHeight: 65,
  },
  avatarAndTitle: {
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    width: 60,
    height: 60,
    marginRight: theme.spacing(2),
  },
  price: {
    background: fade(theme.palette.success.light, 0.2),
    color: theme.palette.success.light,
    fontWeight: "bold",
    borderRadius: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  button: {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
  added: {
    color: theme.palette.success.light,
    fontWeight: "bold",
    "& .MuiIcon-root": {
      fontWeight: "bold",
      fontSize: "1em",
    },
  },
}));

const AdditionalServicesPage: FC<RouteComponentProps> = ({ ...props }) => {
  const classes = useStyles();
  const { search } = useLocation();
  const history = useHistory();

  const {
    loadProducts,
    loadingProducts,
    data: { cart, additional_services },
    actions: { addToCart, addRedirectUrl },
  } = usePayment();

  useEffect(() => {
    loadProducts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let query = queryString.parse(search.split("?").join(""));
    if (!loadingProducts) {
      if (query.pack) {
        addToCart(+query.pack);

        if (query.redirectUrl) {
          addRedirectUrl(query.redirectUrl);
        } else {
          addRedirectUrl(`0/${Routes.PROGRAMS}`);
        }

        history.push(`/${Routes.CHECKOUT}`);
      } else {
        history.push(`/`);
      }
    }
  }, [loadingProducts]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loadingProducts) return <Loading />;

  return <Loading />;
  // return (
  //   <div className={classes.root}>
  //     <Container maxWidth={'lg'}>
  //       <PageHeader title={'Additional Services'} subtitle={"Please select additional services if you need."} />
  //     </Container>
  //     <Container maxWidth={'lg'}>
  //       <Grid container spacing={3} className={classes.paper}>
  //         {
  //           additional_services.length === 0
  //             ?
  //             <Error text={'No Services found'} />
  //             :
  //             additional_services.map(item => (
  //               <Grid item xs={12} md={6} key={`AdditionalServices_${item.id}`}>
  //                 <Paper className={classes.serviceItem}>
  //                   <Grid container spacing={2} alignItems={'center'} className={classes.serviceItemGrid}>
  //                     <Grid item xs={9} sm={6} lg={6}>
  //                       <div className={classes.avatarAndTitle}>
  //                         <div>
  //                           <Avatar variant={'rounded'} className={classes.avatar}>
  //                             <FontIcon name={item.icon} />
  //                           </Avatar>
  //                         </div>
  //                         <div>
  //                           <Typography variant={'subtitle2'}>
  //                             {item.name}
  //                           </Typography>
  //                         </div>
  //                       </div>
  //                     </Grid>
  //                     <Grid item xs={3} sm={2} lg={2}>
  //                       <Typography align={'center'} className={classes.price}>
  //                         ${item.price}
  //                       </Typography>
  //                     </Grid>
  //                     <Grid item xs={12} sm={4} lg={4}>
  //                       {
  //                         cart.find(cartItem => cartItem.id === item.id)
  //                           ?
  //                           (
  //                             <Typography align={'center'} className={classes.added}>
  //                               <FontIcon name={'check'} /> Added
  //                             </Typography>
  //                           )
  //                           :
  //                           (
  //                             <Button
  //                               fullWidth
  //                               variant={'contained'}
  //                               color={'secondary'}
  //                               className={classes.button}
  //                               onClick={() => {
  //                                 addToCart(item.id)
  //                               }}
  //                             >
  //                               Add to cart
  //                             </Button>
  //                           )
  //                       }
  //                     </Grid>
  //                   </Grid>
  //                 </Paper>
  //               </Grid>
  //             ))
  //         }
  //       </Grid>
  //     </Container>
  //   </div>
  // );
};

export default AdditionalServicesPage;
